<!--
	InfoButton: "?" IconButton that reveals a small info popover, positioned with CSS anchor
	positioning so it tracks the trigger on scroll and flips when it would overflow.
-->
<script lang="ts">
	import IconButton from './IconButton.svelte';

	interface Props {
		content: string;
		/** Preferred side of the trigger; the popover flips when there's no room. */
		position?: 'top' | 'left';
		/** Max width of the popover in pixels. */
		maxWidth?: number;
		noBorder?: boolean;
	}

	const { content, position = 'top', maxWidth = 320, noBorder = false }: Props = $props();

	const id = $props.id();
	const anchorName = `--info-${id}`;
</script>

<IconButton
	variant={noBorder ? 'quiet' : 'outlined'}
	size="xs"
	{anchorName}
	popovertarget={id}
	aria-describedby={id}
	aria-label="More information">
	?
</IconButton>

<div
	{id}
	class="infoPopover {position}"
	popover="auto"
	role="tooltip"
	style:position-anchor={anchorName}
	style:max-width="{maxWidth}px">
	{content}
</div>

<style>
	[popover].infoPopover {
		position: fixed;
		inset: auto;
		margin: var(--space-2);
		box-shadow: var(--shadow-lg);
		border-radius: var(--radius);
		background-color: var(--tooltip-surface);
		padding: var(--space-2) var(--space-3);
		color: var(--tooltip-text);
		font-size: var(--font-size-sm);
		line-height: 1.35;
		text-align: start;

		&.top {
			position-area: block-start;
			position-try-fallbacks: flip-block, flip-inline;
		}

		&.left {
			position-area: inline-start;
			position-try-fallbacks: flip-inline, flip-block;
		}
	}
</style>
